import type { IErrorResponse, ProductVotePayload } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useVoteProduct = (): UseMutationResult<
  [],
  IErrorResponse,
  ProductVotePayload
> => {
  const { t } = useTranslation('messages');
  return useMutation({
    mutationFn: (data) => api.post(urls.voteProduct, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('yourCommentSuccessfullyRegistered'),
      });
    },
  });
};

export default useVoteProduct;
